(function(){
  'use strict';

  var config = window.__viCardConfig || {};
  var moneyFormat = config.moneyFormat || '${{amount}}';
  var cardMediaCache = window.__piCardMediaCache;
  if(!cardMediaCache || typeof cardMediaCache !== 'object'){
    cardMediaCache = Object.create(null);
    window.__piCardMediaCache = cardMediaCache;
  }

  function fmt(cents){
    try{
      if(window.Shopify && typeof Shopify.formatMoney === 'function'){
        return Shopify.formatMoney(cents, moneyFormat);
      }
    }catch(_){}
    var value = Number(cents || 0) / 100;
    return 'R$ ' + value.toFixed(2).replace('.', ',');
  }

  function isVideoUrl(url){
    if(!url) return false;
    return /\.(mp4|webm|mov)(\?|$)/i.test(String(url)) || /\/videos\//i.test(String(url));
  }

  function normalizeMediaData(data){
    var payload = data && typeof data === 'object' ? data : {};
    var primary = payload.primary || payload.img || '';
    var secondary = payload.secondary || payload.img2 || '';
    var video = payload.video || '';
    if(!video && isVideoUrl(primary)){
      video = primary;
      primary = '';
    }
    return {
      primary: primary,
      secondary: secondary,
      video: video
    };
  }

  function readRootMedia(root){
    return normalizeMediaData({
      primary: root.getAttribute('data-variant-main') || '',
      secondary: root.getAttribute('data-variant-hover') || '',
      video: root.getAttribute('data-variant-video') || ''
    });
  }

  function fetchVariantMedia(handle, variantId){
    var cleanHandle = handle ? String(handle).trim() : '';
    var cleanVariantId = variantId ? String(variantId).trim() : '';
    if(!cleanHandle || !cleanVariantId){
      return Promise.resolve(normalizeMediaData(null));
    }
    var cacheKey = cleanHandle + ':' + cleanVariantId;
    if(cardMediaCache[cacheKey]){
      return cardMediaCache[cacheKey];
    }
    var url = '/products/' + encodeURIComponent(cleanHandle) + '?view=variant-card-media&variant=' + encodeURIComponent(cleanVariantId);
    cardMediaCache[cacheKey] = fetch(url, {
      credentials: 'same-origin',
      headers: { accept: 'application/json' }
    }).then(function(response){
      if(!response.ok){
        throw new Error('variant-card-media:' + response.status);
      }
      return response.json();
    }).then(function(payload){
      return normalizeMediaData(payload);
    }).catch(function(){
      delete cardMediaCache[cacheKey];
      return normalizeMediaData(null);
    });
    return cardMediaCache[cacheKey];
  }

  function createImage(src, className, altText){
    if(!src) return null;
    var img = document.createElement('img');
    img.className = className;
    img.loading = 'eager';
    img.decoding = 'async';
    img.sizes = '(min-width:1200px)25vw,(min-width:750px)33vw,50vw';
    img.src = src;
    img.srcset = src + ' 1200w';
    img.alt = altText || '';
    img.width = 600;
    img.height = 600;
    return img;
  }

  function createVideo(src, className){
    if(!src) return null;
    var video = document.createElement('video');
    video.autoplay = true;
    video.muted = true;
    video.loop = true;
    video.playsInline = true;
    video.className = className;
    video.setAttribute('autoplay', '');
    video.setAttribute('muted', '');
    video.setAttribute('loop', '');
    video.setAttribute('playsinline', '');
    var source = document.createElement('source');
    source.src = src;
    source.type = 'video/mp4';
    video.appendChild(source);
    return video;
  }

  function renderMedia(root, media){
    var mediaBox = root.querySelector('[data-media-box]');
    if(!mediaBox) return;
    mediaBox.textContent = '';
    var wrapper = document.createElement('div');
    wrapper.className = 'vi-imgbox';
    var altText = root.getAttribute('data-product-title') || '';

    if(media.video){
      var primaryVideo = createVideo(media.video, 'vi-video');
      if(primaryVideo) wrapper.appendChild(primaryVideo);
      var hoverVideoOrImage = media.secondary || media.primary;
      if(hoverVideoOrImage){
        if(isVideoUrl(hoverVideoOrImage)){
          var secondaryVideo = createVideo(hoverVideoOrImage, 'vi-video vi-video--secondary');
          if(secondaryVideo) wrapper.appendChild(secondaryVideo);
        } else {
          var secondaryImage = createImage(hoverVideoOrImage, 'vi-img vi-img--secondary', altText);
          if(secondaryImage) wrapper.appendChild(secondaryImage);
        }
      }
    } else {
      var primaryImage = createImage(media.primary || media.secondary, 'vi-img vi-img--primary', altText);
      if(primaryImage) wrapper.appendChild(primaryImage);
      if(media.secondary){
        if(isVideoUrl(media.secondary)){
          var hoverVideo = createVideo(media.secondary, 'vi-video vi-video--secondary');
          if(hoverVideo) wrapper.appendChild(hoverVideo);
        } else {
          var hoverImage = createImage(media.secondary, 'vi-img vi-img--secondary', altText);
          if(hoverImage) wrapper.appendChild(hoverImage);
        }
      }
    }

    mediaBox.appendChild(wrapper);
  }

  function updateInstallments(root, priceCents){
    var installEl = root.querySelector('[data-install]');
    if(!installEl) return;
    var minInstallCents = Number(config.minInstallmentCents) || (Number(installEl.dataset.minInstall || 5) * 100);
    var maxInstallments = Number(config.maxInstallments) || Number(installEl.dataset.maxInstall || 10) || 10;
    var qty = minInstallCents > 0 ? Math.floor(priceCents / minInstallCents) : 0;
    if(qty > maxInstallments) qty = maxInstallments;
    if(qty < 1) qty = 1;
    if(qty > 1){
      var per = Math.ceil(priceCents / qty);
      installEl.style.display = '';
      installEl.textContent = 'ou em até ' + qty + 'x ' + fmt(per).replace('R$ ', '') + ' sem juros';
    } else {
      installEl.style.display = 'none';
      installEl.textContent = '';
    }
  }

  function setActive(root, btn){
    root.querySelectorAll('.vi-swatch.is-active').forEach(function(node){
      node.classList.remove('is-active');
      node.setAttribute('aria-pressed', 'false');
    });
    btn.classList.add('is-active');
    btn.setAttribute('aria-pressed', 'true');
  }

  function setupArrows(root){
    var swCont = root.querySelector('[data-swatches]');
    var btnPrev = root.querySelector('.vi-sw-nav.prev');
    var btnNext = root.querySelector('.vi-sw-nav.next');
    if(!swCont || !btnPrev || !btnNext) return;

    function updateArrows(){
      var overflow = swCont.scrollWidth - swCont.clientWidth > 2;
      btnPrev.classList.toggle('is-visible', overflow);
      btnNext.classList.toggle('is-visible', overflow);
      if(!overflow) return;
      var max = swCont.scrollWidth - swCont.clientWidth;
      var at = Math.max(0, Math.min(swCont.scrollLeft, max));
      btnPrev.classList.toggle('is-hidden', at <= 0);
      btnNext.classList.toggle('is-hidden', at >= max - 1);
    }

    if(root.__piArrowsBound) {
      requestAnimationFrame(updateArrows);
      return;
    }
    root.__piArrowsBound = true;
    btnPrev.addEventListener('click', function(){ swCont.scrollBy({ left: -160, behavior: 'smooth' }); });
    btnNext.addEventListener('click', function(){ swCont.scrollBy({ left: 160, behavior: 'smooth' }); });
    swCont.addEventListener('scroll', updateArrows, { passive: true });
    window.addEventListener('resize', updateArrows);
    requestAnimationFrame(updateArrows);
  }

  function readInlineButtonMedia(btn){
    return normalizeMediaData({
      img: btn.getAttribute('data-img') || '',
      img2: btn.getAttribute('data-img2') || '',
      video: btn.getAttribute('data-video') || ''
    });
  }

  function resolveButtonMedia(root, btn){
    var inlineMedia = readInlineButtonMedia(btn);
    if(inlineMedia.primary || inlineMedia.secondary || inlineMedia.video){
      return Promise.resolve(inlineMedia);
    }
    var buttonVariantId = btn.getAttribute('data-variant-id') || '';
    var rootVariantId = String(root.getAttribute('data-variant-id') || '');
    if(buttonVariantId && rootVariantId && buttonVariantId === rootVariantId){
      var currentMedia = readRootMedia(root);
      if(currentMedia.primary || currentMedia.secondary || currentMedia.video){
        return Promise.resolve(currentMedia);
      }
    }
    return fetchVariantMedia(root.getAttribute('data-product-handle') || '', buttonVariantId).then(function(media){
      if(media.primary || media.secondary || media.video){
        return media;
      }
      return readRootMedia(root);
    });
  }

  function applySelection(root, btn, media){
    setActive(root, btn);

    var variantId = btn.getAttribute('data-variant-id') || '';
    var variantUrl = btn.getAttribute('data-variant-url') || '';
    var priceCents = Number(btn.getAttribute('data-price-cents') || 0);
    var compareCents = Number(btn.getAttribute('data-compare-cents') || 0);
    var linkImg = root.querySelector('[data-media-link]');
    var nowEl = root.querySelector('[data-now]');
    var wasEl = root.querySelector('[data-was]');
    var quickPop = root.querySelector('quick-buy-popover');
    var quickDrw = root.querySelector('quick-buy-drawer');
    var formVar = root.querySelector('[data-vi-variant-input]');

    root.setAttribute('data-variant-id', variantId);
    if(media.primary){
      root.setAttribute('data-variant-main', media.primary);
    } else {
      root.removeAttribute('data-variant-main');
    }
    if(media.secondary){
      root.setAttribute('data-variant-hover', media.secondary);
    } else {
      root.removeAttribute('data-variant-hover');
    }
    if(media.video){
      root.setAttribute('data-variant-video', media.video);
    } else {
      root.removeAttribute('data-variant-video');
    }

    if(linkImg && variantUrl) linkImg.href = variantUrl;
    if(quickPop && variantUrl) quickPop.setAttribute('href', variantUrl);
    if(quickDrw && variantUrl) quickDrw.setAttribute('href', variantUrl);
    if(formVar && variantId) formVar.value = variantId;

    renderMedia(root, media);

    if(nowEl) nowEl.textContent = fmt(priceCents);
    if(wasEl){
      if(compareCents > priceCents && compareCents > 0){
        wasEl.style.display = '';
        wasEl.textContent = fmt(compareCents);
      } else {
        wasEl.style.display = 'none';
        wasEl.textContent = '';
      }
    }
    updateInstallments(root, priceCents);
  }

  function initCard(root){
    if(!root || root.__piBound__) return;
    root.__piBound__ = true;
    root.__piRequestId = 0;
    setupArrows(root);

    root.addEventListener('click', function(event){
      var btn = event.target && event.target.closest ? event.target.closest('.vi-swatch') : null;
      if(!btn || !root.contains(btn)) return;
      event.preventDefault();
      var requestId = ++root.__piRequestId;
      resolveButtonMedia(root, btn).then(function(media){
        if(requestId !== root.__piRequestId) return;
        applySelection(root, btn, media);
      });
    });

    root.addEventListener('pointerover', function(event){
      var btn = event.target && event.target.closest ? event.target.closest('.vi-swatch') : null;
      if(!btn || !root.contains(btn)) return;
      resolveButtonMedia(root, btn).catch(function(){});
    }, { passive: true });

    root.addEventListener('focusin', function(event){
      var btn = event.target && event.target.closest ? event.target.closest('.vi-swatch') : null;
      if(!btn || !root.contains(btn)) return;
      resolveButtonMedia(root, btn).catch(function(){});
    });
  }

  function initWithin(scope){
    var ctx = scope && scope.querySelectorAll ? scope : document;
    ctx.querySelectorAll('product-item[data-pi-card="1"][id]').forEach(initCard);
  }

  document.addEventListener('DOMContentLoaded', function(){
    initWithin(document);
  });
  document.addEventListener('collection:items:added', function(event){
    initWithin(event && event.detail && event.detail.scope ? event.detail.scope : document);
  });
  document.addEventListener('search:items:added', function(event){
    initWithin(event && event.detail && event.detail.scope ? event.detail.scope : document);
  });
  document.addEventListener('facets:updated', function(event){
    initWithin(event && event.detail && event.detail.scope ? event.detail.scope : document);
  });
  document.addEventListener('shopify:section:load', function(event){
    initWithin(event && event.target ? event.target : document);
  });

  if(window.MutationObserver){
    var observer = new MutationObserver(function(records){
      records.forEach(function(record){
        if(!record.addedNodes) return;
        record.addedNodes.forEach(function(node){
          if(!node || node.nodeType !== 1) return;
          if(node.matches && node.matches('product-item[data-pi-card="1"][id]')){
            initCard(node);
            return;
          }
          if(node.querySelectorAll){
            node.querySelectorAll('product-item[data-pi-card="1"][id]').forEach(initCard);
          }
        });
      });
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  initWithin(document);
})();
